import {
  FIELD_TYPE_PRODUCT_IMAGE,
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
} from "@frontend/constants/type-fields-of-template";
import {
  backgroundThemeImageMapper,
  productImageMapper
} from './field-mappers/index';

export const LAYER_SUBTYPE = {
  IMAGE: 'Image',
  TEXT: 'Text'
}

/**
 *
 * @type SupportedField[]
 */
export const SUPPORTED_FIELDS = [
  {
    type: FIELD_TYPE_BACKGROND_THEME_IMAGE,
    indexable: true,
    map: backgroundThemeImageMapper
  },
  {
    type: FIELD_TYPE_PRODUCT_IMAGE,
    indexable: true,
    map: productImageMapper
  },
  // {
  //   type: FIELD_TYPE_MULTI_LINE_TEXT,
  //   map: multiLineTextMapper
  // }
];
